import { GenericPreview } from '../GenericPreview';
import { Attachment } from '../../schemas/attachment';
import { formatFileSize } from '../../utils/formatFileSize';

interface Props {
  artistName: string;
  attachment: Attachment;
  onClick: (attachment: Attachment) => void;
  onDelete: (attachment: Attachment) => void;
  showDelete: boolean;
}

export function SignedContractPreview({
  artistName,
  attachment,
  onClick,
  onDelete,
  showDelete,
}: Props) {
  return (
    <GenericPreview
      iconName="file"
      iconAriaLabel="Document icon"
      title={`Claim Contract ${artistName}`}
      note={`${attachment.name} ${formatFileSize(attachment.size)}`}
      buttonVariant="neutral"
      buttonLabel={showDelete ? 'Delete' : undefined}
      onIconClick={() => onClick(attachment)}
      onTitleClick={() => onClick(attachment)}
      onButtonClick={() => onDelete(attachment)}
    />
  );
}
